import { ModuleWithProviders, NgModule } from "@angular/core";
import { RouteService } from "@obg/ngx.router";

import { ServerRouteService } from "./route/server-route.service";

@NgModule()
export class UniversalRouterModule {
	static forRoot(): ModuleWithProviders<UniversalRouterModule> {
		return {
			ngModule: UniversalRouterModule,
			providers: [{ provide: RouteService, useClass: ServerRouteService }],
		};
	}
}
